export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.17-1625.54',
  commitId: '6f3c9c92144beb23da96d9e2297c74f0b8224e52',
  commitTime: '2026-02-17T16:25:54.000Z',
});
